// src/vo/ThongBao.js
import React, { useCallback, useEffect, useRef, useState } from "react";

// ============================================================
// 💬 THÔNG BÁO NGẮN — "✅ Đã lưu", "⚠️ Không xóa được"
// ------------------------------------------------------------
// Trước Đợt N1, SÁU file tự viết lại đúng đoạn này:
//
//     const [bao, setBao] = useState("");
//     const noiBao = (chu, giay = 3000) => {
//       setBao(chu);
//       setTimeout(() => setBao(""), giay);
//     };
//
// ViecNha · ChiTieu · DiCho · DanhBa · DiemDanh · ThucDonTuan. Sáu bản
// giống hệt nhau, chỉ khác thời gian mặc định (3000 và 3500). Đã đối chiếu
// từng bản trước khi gộp — gộp mấy bản KHÁC nhau thành một là làm hỏng chỗ
// đang đúng.
//
// ⚠️ MỘT LỖI THẬT MÀ BẢN CŨ CÓ, BẢN NÀY CHỮA:
// `setTimeout` cũ không bao giờ được hủy. Nếu người dùng chuyển trang trước
// khi hết 3 giây thì hẹn giờ vẫn chạy rồi gọi setState trên một component đã
// tháo — React kêu cảnh báo trong console. Bản này giữ id hẹn giờ trong ref
// và dọn khi tháo.
//
// Cách dùng:
//     const { bao, noiBao } = useThongBao();
//     ...
//     noiBao("✅ Đã lưu");
//     <ThongBao bao={bao} />
// ============================================================

export function useThongBao(giayMacDinh = 3000) {
  const [bao, setBao] = useState("");
  const henGio = useRef(null);

  const noiBao = useCallback(
    (chu, giay = giayMacDinh) => {
      if (henGio.current) clearTimeout(henGio.current);
      setBao(chu);
      henGio.current = setTimeout(() => setBao(""), giay);
    },
    [giayMacDinh],
  );

  // Dọn hẹn giờ khi component bị tháo
  useEffect(() => {
    return () => {
      if (henGio.current) clearTimeout(henGio.current);
    };
  }, []);

  return { bao, noiBao };
}

export function ThongBao({ bao }) {
  if (!bao) return null;
  return (
    <div className="notification" role="status">
      {bao}
    </div>
  );
}
